import React, { useState, useEffect, useRef } from 'react'
import logo from '../assets/Deli_Logo.svg'
import logoWhite from '../assets/Deli_Logo_White.svg'
import { AiOutlineSetting } from "react-icons/ai";
import { IoChatbubblesOutline } from "react-icons/io5";
import { FiEdit3 } from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";
import Profile from "../components/Profile";
import ProfileCard from './profileModal/profileCard';
import ClientContainer from '../components/ClientContainer';
import { useNavigate, useParams } from "react-router-dom";

export default function Sidebar({ setfeedback, closeSidebar, setCloseSidebar, userName, picture, width = '272px', 
  clientsList, setClientPopUp, openChatActive, setOpenChatActive, newClientActive, setNewClientActive, user, tokenId}) {

  const [sideBarWidth, setSideBarWidth] = useState(width);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const profileMenu = useRef(null)
  const navigate = useNavigate();
  const {queryParam} = useParams();

  const closeOpenMenus = (e) => {
    if(profileMenu.current && !profileMenu.current?.contains(e.target)){
      setIsProfileOpen(false)
    }
  }

  useEffect(() => {
    if(window.innerWidth < 768){
      setSideBarWidth('100%');
    }

    if(!queryParam)
      setOpenChatActive(true)
    else {
      setOpenChatActive(false)
      setNewClientActive(false)
      setClientPopUp(false)
    }

    document.addEventListener('mousedown', closeOpenMenus)
  }, [queryParam])

  return (
    <div style={{ width: closeSidebar ? sideBarWidth : '0', visibility: closeSidebar ? 'visible' : 'hidden', top: 0, left: 0  }} className='transition-all z-10 absolute lg:static'>
      <div className='w-full bg-white min-h-screen relative'>
        <nav className='flex justify-between pt-6 px-6 pb-8'>
          <div >
            <img width={40} src={logo} alt="" />
          </div>
          <div className='flex items-center gap-4'>
            <div className='-Z-5 relative flex items-center justify-center gap-10 shadowBox  bg-white rounded-md'>
              <div className='pt-1 cursor-pointer transition-transform duration-300 hover:scale-105' onClick={() => setfeedback(true)}>
                <IoChatbubblesOutline size={30} className='hover:text-blue-600 text-gray-400' />
              </div>
            </div>
          </div>
        </nav>
        <div className="inner-sidebar px-6">
          <button className={` ${ !newClientActive ? 'bg-[#F6F8FC] text-[#98A2B3] border border-[#EAECF0]' : 'bg-[#072B66] text-white'} py-3 px-3 mb-5 rounded-lg transition-transform duration-300 hover:scale-105 w-full`} onClick={() => {
            setNewClientActive(true);
            setOpenChatActive(false);
            setClientPopUp(true)
          }}>
            <div className='flex justify-between items-center'>
              <div className='flex gap-2'>
                <FaPlus size={22} /> <span>NEW CLIENT</span>
              </div>
              { !newClientActive ? (<img className="w-6 h-6 filter" src={logo} alt="" />) : (<img className="w-6 h-6 filter grayscale" src={logoWhite} alt="" />)}
              
            </div>
          </button>
          <button onClick={() =>{ setClientPopUp(false); setNewClientActive(false); setOpenChatActive(true); navigate("/chat");}} className={`${ openChatActive ? 'bg-[#072B66]  text-white' : 'bg-[#F6F8FC] text-[#98A2B3] border border-[#EAECF0]' } py-3 px-3 mb-5 rounded-lg transition-transform duration-300 hover:scale-105 w-full border-dashed `}>
            <span className='flex gap-2'> <FiEdit3 size={22} />OPEN CHAT</span>
          </button>
        </div>
        <div className='client-list px-6 h-[calc(100vh-352px)] h-[calc(100dvh-352px)] overflow-y-scroll overflow-x-hidden'>
          { clientsList.length > 0 && (
            <ClientContainer clientsList={clientsList}/>
          )}
        </div>
        <div className="px-6 absolute bottom-[28px] lg:bottom-[40px] setting-sidebar mb-6 flex justify-between items-center w-full">
          <div className="flex gap-3 items-center">
            <img src={picture} alt="user" className='w-[40px] height-[40px] rounded-full object-cover' />
            <h6 className='text-gray-700'>{userName}</h6>
          </div>
          <div ref={profileMenu} >
            {isModalOpen && (
              <div className="fixed inset-0 bg-opacity-75 z-50 flex justify-center items-center">
                {/* ProfileCard modal */}
                <ProfileCard closeModal={() => setIsModalOpen(!isModalOpen)} userData={user} tokenId={tokenId} />
              </div>
            )}
            <AiOutlineSetting size={30} className='cursor-pointer transition-transform duration-300 hover:scale-105 hover:text-blue-600 text-gray-400' onClick={() => setIsModalOpen(!isModalOpen)} />
          </div>
        </div>
      </div>
    </div>
  )
};